import { styles } from "./TitleWithListPopup.style";
import { Modal } from "../../components/Modal";

export interface TitleWithListPopupProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  items: string[];
  testSelector?: string;
  closeTestSelector?: string;
}

export const TitleWithListPopup = ({
  isOpen,
  onClose,
  title,
  items,
  testSelector,
  closeTestSelector,
}: TitleWithListPopupProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    size="short"
    className={styles.popupContainer()}
    testSelector={testSelector}
    closeTestSelector={closeTestSelector}
  >
    <div className={styles.popupContent()}>
      <p>{title}</p>
      <ul className={styles.popupList()}>
        {items.map((item) => (
          <li key={item} className={styles.popupListItem()}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  </Modal>
);
